import type { FC, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

export interface AskAlpharunPanelProps {
  /** The panel card's content — typically a `ChatThread`. */
  children: ReactNode;
  className?: string;
}

/**
 * Chrome for the docked "Ask Alpharun" side panel: a rounded card floating on
 * the sidebar background. Width and docking are the caller's concern (the app
 * shell animates the column this sits in).
 */
export const AskAlpharunPanel: FC<AskAlpharunPanelProps> = ({
  children,
  className,
}) => (
  <section
    aria-label="Ask Alpharun"
    className={twMerge(
      "box-border flex h-full min-h-0 w-full min-w-0 flex-col self-stretch bg-sidebar px-2 py-2",
      className,
    )}
  >
    <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden rounded-xl bg-card shadow-xs">
      {children}
    </div>
  </section>
);
